<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space clickabe" @click="msgAlerta=null"><span class="text">{{ msgAlerta }}</span></div>

    <div v-if="!modoEdicao">
        <div v-if="lsDados.length > 0">
            <div class="table-wrapper row-space"><table>
                <thead><tr>
                    <th>OS</th>
                    <th>Nome/Identificação</th>
                    <th>Equipamento</th>
                    <th>Placa</th>
                    <th>Fornecedor</th>
                    <th>Abertura</th>
                </tr></thead>

                <tbody><tr v-for="(obj, index) in lsDados" :key="obj.id" @click="editarCadastro(obj)"
                    :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}"
                >
                    <td class="col-width-char10 right">{{ Funcoes.formatInteger(obj.cdos) }}</td>
                    <td>{{ obj.nmos }}</td>
                    <td class="col-width-char30">{{ obj.nmequipamento }}</td>
                    <td class="col-width-char10 center">{{ obj.placa }}</td>
                    <td class="col-width-char30">{{ obj.nmfornecedor }}</td>
                    <td class="col-width-date center">{{ Funcoes.formatDateFromJson(obj.dtabertura) }}</td>
                </tr></tbody>
            </table></div>

            <div v-if="showPagination" class="pagination">
                <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
                <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
                <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
                <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
                <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
            </div>
        </div>
        <div v-else>
            <EmptyStateComponent
                title="Nenhuma solicitação aguardando orçamento"
                message="Todas as ordens de serviço lançadas já possuem orçamento anexado."
            />
        </div>

        <div class="row-space"></div>
        <div class="row-end">
            <button class="btn-small" @click="closeForm()">Fechar</button>
        </div>
    </div>


    <div v-if="modoEdicao">
        <div class="form-edit-page row-space">
            <div class="row row-space">
                <div class="form-item-char10">
                    <label class="label-caption">OS</label>
                    <div class="field-label field-label-end">{{ Funcoes.formatInteger(osView.cdos) }}</div>
                </div>

                <div class="form-item-char10">
                    <label class="label-caption">Abertura</label>
                    <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(osView.dtabertura) }}</div>
                </div>

                <div class="form-item">
                    <label class="label-caption">Nome/Descrição</label>
                    <div class="field-label">{{ osView.nmos }}</div>
                </div>
                
                <div class="form-item-char40">
                    <label class="label-caption">Equipamento</label>
                    <div class="field-label">{{ osView.nmequipamento }}</div>
                </div>
            </div>


            <div v-show="!modoEdicaoAnexado" class="row row-space">
                <div class="form-item">
                    <AnexoUploadField
                        ref="uploaderRef"
                        :label="'Anexar orçamento:'"
                        :maxSizeMB="20"
                    />
                </div>
                <button class="btn-small" @click="analisarAnexo">Ler Dados</button>
                <button class="btn-small" @click="cancelEdicao">Cancelar</button>
            </div>


            <div v-if="modoEdicaoAnexado" class="row row-space">
                <div class="form-item-char15">
                    <label class="label-caption">Nro Orçamento</label>
                    <input type="text" class="input-right" v-model="edOrcNroDoc" v-number maxlength="9" />
                </div>
                
                <div class="form-item-data">
                    <label class="label-caption">Data</label>
                    <input type="date" v-model="edOrcDtDoc" />
                </div>
                
                <div class="form-item-char30">
                    <label class="label-caption">Valor (R$)</label>
                    <input type="text" class="input-right" v-model="edOrcValor" v-decimal maxlength="15" />
                </div>
                
                <div class="form-item">
                    <label class="label-caption">Nome Contato</label>
                    <input type="text" v-model="edOrcNmContato" maxlength="100" v-uppercase />
                </div>
                
                <button class="btn-small" @click="abrirModalEncerrar">Salvar</button>
                <button class="btn-small" @click="modoEdicaoAnexado=false">Voltar</button>
            </div>
        </div>
    </div>


    <div v-if="orcamentoPreview?.ok && modoEdicaoAnexado" class="orc-preview">
        <div class="orc-table-wrap">
            <table class="orc-table">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Operações</th>
                        <th>Horas</th>
                        <th>Qtd</th>
                        <th>Descrição</th>
                        <th>Código</th>
                        <th class="num">Valor Unit</th>
                        <th class="num">Desc.</th>
                        <th class="num">Líquido</th>
                    </tr>
                </thead>

                <tbody>
                    <tr
                        v-for="item in orcamentoPreview.itens"
                        :key="item.ordem"
                        :class="{ 'linha-alerta': !item.descricao }"
                    >
                        <td>{{ item.ordem }}</td>
                        <td>{{ item.operacoes }}</td>
                        <td>{{ formatDecimal(item.tempo) }}</td>
                        <td>{{ formatDecimal(item.qtd) }}</td>

                        <td>
                            <input
                                v-model="item.descricao"
                                class="orc-input-desc"
                                :class="{ 'input-alerta': !item.descricao }"
                                placeholder="Descrição não identificada"
                            />
                        </td>

                        <td>
                            <input
                                v-model="item.codigo"
                                class="orc-input-cod"
                                placeholder="-"
                            />
                        </td>

                        <td class="num">{{ formatMoney(item.vlunitario + item.vlunitarioMo) }}</td>
                        <td class="num">{{ formatMoney(item.desconto) }}</td>
                        <td class="num">{{ formatMoney(item.valorLiquido + item.vlmo) }}</td>
                    </tr>
                </tbody>

                <tfoot>
                    <tr>
                        <td colspan="8" class="num"><strong>Total ítens</strong></td>
                        <td class="num"><strong>{{ formatMoney(totalItens) }}</strong></td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>


    <ConfirmModal ref="confirmModal" />
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/utils';
import { globalStore } from '@/globals';
import AnexoUploadField from '@/components/fields/AnexoUploadField.vue';
import ConfirmModal from '@/components/modals/ConfirmModal.vue';
import EmptyStateComponent from '@/components/EmptyStateComponent.vue';

const emit = defineEmits(['close']);

const confirmModal = ref(null);
const isLoading = ref(false);
const lsDados = ref([]);
const modoEdicao = ref(false);
const modoEdicaoAnexado = ref(false);
const msgAlerta = ref(null);

const orcamentoPreview = ref(null);
const osView = ref({});

const edOrcNroDoc = ref(null);
const edOrcDtDoc = ref(null);
const edOrcValor = ref(null);
const edOrcNmContato = ref(null);

const uploaderRef = ref(null); //01-02-2026 TESTE NOVO COMPONENTE

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const lsDadosMain = ref([]);
const showPagination = ref(false);


const totalItens = computed(() => {
    if (!orcamentoPreview.value?.itens) return 0;

    return orcamentoPreview.value.itens.reduce((total, item) => {
        const valorLiquido = Number(item.valorLiquido) || 0;
        const vlMo = Number(item.vlmo) || 0;
        return total + valorLiquido + vlMo;
    }, 0);
})


function formatMoney(value) {
    return Number(value || 0).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    });
}


function formatDecimal(value) {
    return Number(value || 0).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
}


async function abrirModalEncerrar(){
    const confirmado = await confirmModal.value.show({
        message: "Confirma anexo do orçamento e encerramento da etapa?",
        confirmText: 'Sim',
        cancelText: 'Não'
    })
    if (confirmado){salvarAnexoOrcamento()}
}


async function analisarAnexo(){
    msgAlerta.value=null;
    if (!uploaderRef.value?.hasFile()){
        msgAlerta.value="Nenhum arquivo selecionado";
        return;
    }

    try{
        const file = uploaderRef.value.getFile();

        const response = await Api.genericPostFormData(
            '/frota/orcamentos/importar-preview',
            file);

        orcamentoPreview.value = response;

        console.log(orcamentoPreview.value);

        edOrcNroDoc.value = orcamentoPreview.value.orcamento.numero;
        edOrcDtDoc.value = Funcoes.parseDataInput(orcamentoPreview.value.orcamento.data);
        edOrcValor.value = Funcoes.formatDecimal(orcamentoPreview.value.orcamento.totalGeral);

        modoEdicaoAnexado.value = true;
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}


function cancelEdicao(){
    if (lsDados.value.length > 0){
        msgAlerta.value=null;
        modoEdicao.value = false;
    }else{
        closeForm();
    }
}


function closeForm() { emit('close'); }


function editarCadastro(obj) {
    osView.value = obj;
    modoEdicao.value=true;
}


function updatePaginatedData() {
    const startIndex = (currentPage.value - 1) * globalStore.itensPorPagina;
    const endIndex = (startIndex + globalStore.itensPorPagina);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}


async function lerDados() {
    try {
        msgAlerta.value = null;
        isLoading.value = true;

        const payload = {
            idmunicipio: globalStore.idmunicipio,
            intparam1: 4,
            idlogin: globalStore.idlogin,
        };

        const req = await Api.genericPost('/dados/manut_os', payload);
        lsDadosMain.value = req || [];
        currentPage.value = 1;
        showPagination.value = (lsDadosMain.value.length > globalStore.itensPorPagina);
        updatePaginatedData();
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}


async function salvarAnexoOrcamento(){
    try{
        msgAlerta.value = null;
        isLoading.value = true;


        // SALVAR ARQUIVO ANEXO
        let idAnexoOrcamento;
        const file = uploaderRef.value.getFile();
        const ext = (file.name.split('.').pop() || '').toLowerCase();
        const payloadAnexo = {
            idmunicipio: globalStore.idmunicipio,
            idlogin: globalStore.idlogin,
            tipo: file.type === 'application/pdf' ? '0' : '1',
            fname: file.name,
            file_ext: ext,
            mime_type: file.type || 'application/octet-stream'
        };
        const result = await uploaderRef.value.upload(payloadAnexo);
        idAnexoOrcamento = result.id;


        // SALVAR ÍTENS DO ORÇAMENTO
        for (const item of orcamentoPreview.value.itens){
            const payloadItem = {
                idos: osView.value.id,
                ordem: item.ordem,
                codigo: item.codigo,
                descricao: item.descricao,
                operacao: item.operacao,
                qtdhoras: item.tempo,
                vlunitario_mo: item.vlunitarioMo,
                vlmo: item.vlmo,
                qtdd: item.qtd,
                vlunitario: item.vlunitario,
                vlbruto: item.valor,
                vldesconto: item.desconto,
                vlliquido: item.valorLiquido,
                idlogin: globalStore.idlogin
            }
            const respItem = await Api.genericPut('/cad/manut_os_item', payloadItem);
            if (respItem.bolok != 1) throw new Error(respItem.erro);
            /*  Result.AddPair('operacoes', '');
            Result.AddPair('descricao', LimparDescricaoItem(Descricao));
            Result.AddPair('codigo', Referencia);
            Result.AddPair('fornecimento', 'Traz Valor');
            Result.AddPair('unidade', Und);

            Result.AddPair('tempo', TJSONNumber.Create(qtdHoras));
            Result.AddPair('vlunitarioMo', TJSONNumber.Create(vlUnitarioMo));
            Result.AddPair('vlmo', TJSONNumber.Create(vlMo));

            Result.AddPair('qtd', TJSONNumber.Create(qtdd));
            Result.AddPair('vlunitario', TJSONNumber.Create(vlUnitario));
            Result.AddPair('valor', TJSONNumber.Create(vlPecas));
            Result.AddPair('desconto', TJSONNumber.Create(0));
            Result.AddPair('valorLiquido', TJSONNumber.Create(vlPecas));*/
        }


        // SALVAR DADOS DO ORÇAMENTO
        const payloadOS = {
            id: osView.value.id,
            orcamento_idlogin: globalStore.idlogin,
            orcamento_nrodoc: Funcoes.integerFromString(edOrcNroDoc.value),
            orcamento_dtdoc: edOrcDtDoc.value,
            orcamento_valor: Funcoes.decimalFromString(edOrcValor.value),
            orcamento_nmcontato: edOrcNmContato.value,
            orcamento_idanexo: idAnexoOrcamento,
            idlogin: globalStore.idlogin,
        }
        const respOs = await Api.genericPut('/cad/manut_os', payloadOS);
        if (respOs.bolok != 1) throw new Error(respOs?.erro || 'Não foi possível encerrar digitação da OS');
        modoEdicaoAnexado.value=false;
        modoEdicao.value=false;
        await lerDados();

    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}


async function startPage(){
    await lerDados();
}

onMounted(startPage);
</script>

<style scoped>
.orc-preview {
    margin-top: 16px;
}


.orc-table-wrap {
    width: 100%;
    overflow-x: auto;
    border: 1px solid #d8dee9;
    border-radius: 8px;
}

.orc-table {
    width: 100%;
    min-width: 1050px;
    border-collapse: collapse;
    font-size: 13px;
    background: #fff;
}

.orc-table th {
    background: #f1f5f9;
    font-weight: 600;
    text-align: left;
    padding: 8px;
    border-bottom: 1px solid #d8dee9;
}

.orc-table td {
    padding: 6px 8px;
    border-bottom: 1px solid #eef2f7;
    vertical-align: middle;
}

.orc-table tfoot td {
    background: #f8fafc;
    border-top: 1px solid #d8dee9;
}

.num {
    text-align: right;
    white-space: nowrap;
}

.orc-input-desc,
.orc-input-cod {
    width: 100%;
    border: 1px solid #d8dee9;
    border-radius: 5px;
    padding: 5px 7px;
    font-size: 13px;
    background: #fff;
}

.orc-input-desc {
    min-width: 280px;
}

.orc-input-cod {
    min-width: 90px;
}

.linha-alerta {
    background: #fff8e1;
}

.input-alerta {
    border-color: #f59e0b;
    background: #fffdf4;
}
</style>